import { ColDef, ValueFormatterParams } from '@ag-grid-community/core'
import { formatDate } from 'utils/helpers'

export const getColumns = (page: number) =>
  [
    {
      headerName: 'ID',
      field: 'uuid',
      valueFormatter: (params: ValueFormatterParams) => {
        return (params.node?.rowIndex as number) + 1 + page
      },
      maxWidth: 120,
    },
    { headerName: 'Request', field: 'request' },
    { headerName: 'Response', field: 'response' },
    {
      headerName: 'Creation Date',
      field: 'createdAt',
      valueFormatter: (params: ValueFormatterParams) =>
        formatDate(params.value, { includeTime: true }),
    },
    { headerName: 'Status', field: 'status' },
  ] as ColDef[]
